import React, { useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import { getRandomJokes } from "shared/api/jokes";
import { useDispatch, useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion/dist/framer-motion";
import OCHJoining from "./screens/OCHJoining";
import OCHOver from "./screens/OCHOver";
import OCHPlaying from "./screens/OCHPlaying";
import OCHPrePlay from "./screens/OCHPrePlay";
import OCHRoundOver from "./screens/OCHRoundOver";
import ChooseAsker from "pages/TTL/screens/ChooseAsker";
import NewCardModal from "./components/NewCardModal";
import { usePrevious } from "./utils";
import { set_och_new_card } from "redux/game/action";

const OCH = () => {
  const dispatch = useDispatch();

  const [joke, setJoke] = useState("Loading...");
  const [newKey, setNewKey] = useState("0");

  const {
    gameReducer: {
      currentUser,
      och_new_card,
      roomObj: {
        users,
        id: roomId,
        game_state: {
          draw_deck,
          crazy_suit,
          current_card,
          current_player,
          status,
          player_queue,
          players,
          round_winner
        } = {}
      }
    },
    paramsReducer: {
      gameObj: { screens, sounds }
    }
  } = useSelector((state) => state);

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const nth = (n) => {
    return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
  };
  const isActivePlayer = currentPlayer?.player_id === current_player;
  const amIWinner = currentPlayer?.player_id === round_winner;
  const currentPlayerScoreInfo = players?.filter(
    (item) => item.player_id === currentPlayer.player_id
  );

  const sortedPlayerHands = _.sortBy(players, "player_hand");

  const PlayersRankInfo = users?.map((item) => {
    const index = _.findIndex(
      sortedPlayerHands,
      (el) => el.player_id === item?.player_id
    );

    const positionText =
      index === 0 ? "WINNER" : `${index + 1}${nth(index + 1)} place!`;

    return {
      ...item,
      display_name: item?.display_name,
      profile_image: item?.profile_image,
      rank_tag: positionText
    };
  });

  const ActivePlayerInfo = users?.find(
    (user) => user.player_id === current_player
  );

  const playerTurn = _.findIndex(player_queue, (el) => {
    return el === currentPlayer?.player_id;
  });
  const currentPlayerCard = players?.find(
    (item) => item.player_id === currentPlayer.player_id
  );
  const playerHands =
    players?.filter((el) => el.player_id === currentPlayer.player_id) || [];

  const prevCards = usePrevious(playerHands[0]?.player_hand) || [];
  const CardLength = _.size(currentPlayerCard?.player_hand);
  const closeNewCardModal = () => {
    dispatch(set_och_new_card({}));
  };

  const handle_change_key = () => {
    const random = Math.floor(Math.random() * 500 + 1);
    setNewKey(random);
  };

  useEffect(() => {
    getRandomJokes().then((data) => setJoke(data));

    if (status != "Playing"   ) {
      closeNewCardModal();
    }
  }, [status]);

  useEffect(() => {
    if (CardLength > _.size(prevCards) && !_.isEmpty(prevCards)) {
      const newCard = playerHands[0]?.player_hand.filter((item) => {
        return (
          !prevCards ||
          !prevCards.some(
            (card) => card.suit === item.suit && card.number === item.number
          )
        );
      });
      dispatch(set_och_new_card(newCard));
    }
  }, [roomId, prevCards, CardLength]);

  useEffect(() => {
    return Socket.addListener("play-card-och", handle_change_key());
  }, []);
  useEffect(() => {
    return Socket.addListener("draw-card-och", handle_change_key());
  }, []);

  return (
    <main
      className={`och-main ${status === "Playing" ? "playing" : ""} ${
        status === "Over" ? "over" : ""
      } `}
    >
      <AnimatePresence exitBeforeEnter>
        <div className="och-content">
          {status === "Joining" && <OCHJoining key="OCH_0" users={users} />}
          {status === "PrePlay" && (
            <OCHPrePlay
              key="OCH_1"
              roomId={roomId}
              isActivePlayer={isActivePlayer}
              ActivePlayerInfo={ActivePlayerInfo}
              OtherPlayerTurn={
                playerTurn + 2 + nth(parseInt(playerTurn + 2, 10))
              }
              sounds={sounds}
            />
          )}
          {status === "Playing" && (
            <OCHPlaying
              key={`OCH_${newKey}`}
              joke={joke}
              roomId={roomId}
              users={users}
              DrawDeck={draw_deck}
              isActivePlayer={isActivePlayer}
              ActivePlayerInfo={ActivePlayerInfo}
              crazySuit={crazy_suit}
              ActiveCard={current_card}
              currentPlayerCard={currentPlayerCard}
              currentPlayer={currentPlayer}
              sounds={sounds}
            />
          )}
          {status === "ResultRound" && (
            <OCHRoundOver
              key="OCH_3"
              roomId={roomId}
              users={users}
              joke={joke}
              amIWinner={amIWinner}
              currentPlayerScoreInfo={currentPlayerScoreInfo}
              PlayersRankInfo={PlayersRankInfo}
              currentPlayer={currentPlayer}
            />
          )}
          {status === "Over" && (
            <OCHOver
              key="OCH_4"
              roomId={roomId}
              players={players}
              PlayersRankInfo={PlayersRankInfo}
            />
          )}
        </div>
      </AnimatePresence>

      <AnimatePresence exitBeforeEnter>
        {!_.isEmpty(och_new_card) && (
          <NewCardModal
            handleCloseModal={closeNewCardModal}
            card={och_new_card}
          />
        )}
      </AnimatePresence>
    </main>
  );
};

export default OCH;
